/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClientSurveyModel } from '../models/client-survey-model';
import { createSurvey$Json } from '../fn/survey/create-survey-json';
import { CreateSurvey$Json$Params } from '../fn/survey/create-survey-json';
import { createSurvey$Plain } from '../fn/survey/create-survey-plain';
import { CreateSurvey$Plain$Params } from '../fn/survey/create-survey-plain';
import { deleteSurveyAsync$Json } from '../fn/survey/delete-survey-async-json';
import { DeleteSurveyAsync$Json$Params } from '../fn/survey/delete-survey-async-json';
import { deleteSurveyAsync$Plain } from '../fn/survey/delete-survey-async-plain';
import { DeleteSurveyAsync$Plain$Params } from '../fn/survey/delete-survey-async-plain';
import { getSurvey$Json } from '../fn/survey/get-survey-json';
import { GetSurvey$Json$Params } from '../fn/survey/get-survey-json';
import { getSurvey$Plain } from '../fn/survey/get-survey-plain';
import { GetSurvey$Plain$Params } from '../fn/survey/get-survey-plain';
import { getSurveys$Json } from '../fn/survey/get-surveys-json';
import { GetSurveys$Json$Params } from '../fn/survey/get-surveys-json';
import { getSurveys$Plain } from '../fn/survey/get-surveys-plain';
import { GetSurveys$Plain$Params } from '../fn/survey/get-surveys-plain';
import { updateSurvey$Json } from '../fn/survey/update-survey-json';
import { UpdateSurvey$Json$Params } from '../fn/survey/update-survey-json';
import { updateSurvey$Plain } from '../fn/survey/update-survey-plain';
import { UpdateSurvey$Plain$Params } from '../fn/survey/update-survey-plain';

@Injectable({ providedIn: 'root' })
export class SurveyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSurveys()` */
  static readonly GetSurveysPath = '/api/Survey';

  /**
   * get all surveys.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveys$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveys$Plain$Response(params: GetSurveys$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSurveyModel>>> {
    return getSurveys$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get all surveys.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveys$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveys$Plain(params: GetSurveys$Plain$Params, context?: HttpContext): Observable<Array<ClientSurveyModel>> {
    return this.getSurveys$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientSurveyModel>>): Array<ClientSurveyModel> => r.body)
    );
  }

  /**
   * get all surveys.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurveys$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveys$Json$Response(params: GetSurveys$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSurveyModel>>> {
    return getSurveys$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get all surveys.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurveys$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurveys$Json(params: GetSurveys$Json$Params, context?: HttpContext): Observable<Array<ClientSurveyModel>> {
    return this.getSurveys$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientSurveyModel>>): Array<ClientSurveyModel> => r.body)
    );
  }

  /** Path part for operation `createSurvey()` */
  static readonly CreateSurveyPath = '/api/Survey';

  /**
   * create new survey.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSurvey$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurvey$Plain$Response(params?: CreateSurvey$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyModel>> {
    return createSurvey$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * create new survey.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSurvey$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurvey$Plain(params?: CreateSurvey$Plain$Params, context?: HttpContext): Observable<ClientSurveyModel> {
    return this.createSurvey$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyModel>): ClientSurveyModel => r.body)
    );
  }

  /**
   * create new survey.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSurvey$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurvey$Json$Response(params?: CreateSurvey$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyModel>> {
    return createSurvey$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * create new survey.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSurvey$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSurvey$Json(params?: CreateSurvey$Json$Params, context?: HttpContext): Observable<ClientSurveyModel> {
    return this.createSurvey$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyModel>): ClientSurveyModel => r.body)
    );
  }

  /** Path part for operation `getSurvey()` */
  static readonly GetSurveyPath = '/api/Survey/{surveyId}';

  /**
   * get survey by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurvey$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurvey$Plain$Response(params: GetSurvey$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyModel>> {
    return getSurvey$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get survey by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurvey$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurvey$Plain(params: GetSurvey$Plain$Params, context?: HttpContext): Observable<ClientSurveyModel> {
    return this.getSurvey$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyModel>): ClientSurveyModel => r.body)
    );
  }

  /**
   * get survey by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSurvey$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurvey$Json$Response(params: GetSurvey$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyModel>> {
    return getSurvey$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * get survey by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSurvey$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSurvey$Json(params: GetSurvey$Json$Params, context?: HttpContext): Observable<ClientSurveyModel> {
    return this.getSurvey$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyModel>): ClientSurveyModel => r.body)
    );
  }

  /** Path part for operation `updateSurvey()` */
  static readonly UpdateSurveyPath = '/api/Survey/{surveyId}';

  /**
   * update survey.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSurvey$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSurvey$Plain$Response(params: UpdateSurvey$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyModel>> {
    return updateSurvey$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * update survey.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSurvey$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSurvey$Plain(params: UpdateSurvey$Plain$Params, context?: HttpContext): Observable<ClientSurveyModel> {
    return this.updateSurvey$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyModel>): ClientSurveyModel => r.body)
    );
  }

  /**
   * update survey.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSurvey$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSurvey$Json$Response(params: UpdateSurvey$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyModel>> {
    return updateSurvey$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * update survey.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSurvey$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSurvey$Json(params: UpdateSurvey$Json$Params, context?: HttpContext): Observable<ClientSurveyModel> {
    return this.updateSurvey$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientSurveyModel>): ClientSurveyModel => r.body)
    );
  }

  /** Path part for operation `deleteSurveyAsync()` */
  static readonly DeleteSurveyAsyncPath = '/api/Survey/{surveyId}';

  /**
   * delete survey by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSurveyAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyAsync$Plain$Response(params: DeleteSurveyAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return deleteSurveyAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * delete survey by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSurveyAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyAsync$Plain(params: DeleteSurveyAsync$Plain$Params, context?: HttpContext): Observable<number> {
    return this.deleteSurveyAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /**
   * delete survey by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSurveyAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyAsync$Json$Response(params: DeleteSurveyAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return deleteSurveyAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * delete survey by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSurveyAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSurveyAsync$Json(params: DeleteSurveyAsync$Json$Params, context?: HttpContext): Observable<number> {
    return this.deleteSurveyAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

}
